<template>
  <t-modal @modal-close="handleClose">
    <a href="#" class="t-modal__close" role="button" @click.prevent="handleClose">
      <t-icon icon="times" />
    </a>

    <div class="t-modal__header">
      <h2><slot name="header"></slot></h2>
    </div>

    <div class="t-modal__body">
      <slot />

      <div class="t-confirm__confirmation" v-if="confirmable">
        <pre class="t-confirm__confirmation-value">{{ confirmation }}</pre>
        <input
          type="text"
          class="t-confirm__confirmation-input"
          :placeholder="confirmationPlaceholder"
          v-model="confirmationValue"
        >
      </div>
    </div>

    <form @submit="handleConfirmation">
      <t-button
        block
        :disabled="confirmable && confirmationDoesntMatch"
        :type="buttonType"
        native-type="submit"
      >{{ buttonLabel }}</t-button>
    </form>
  </t-modal>
</template>

<script>
import { buttonVariants } from '../../enums';
import { TButton } from '../TButton';
import TModal from '../TModal';
import ColorTypeMixin from '../../mixins/ColorTypeMixin';

export default {
  name: 't-confirm',

  mixins: [ColorTypeMixin],

  props: {
    buttonLabel: {
      type: String,
      default: 'Confirm',
    },

    buttonType: {
      type: String,
      default: buttonVariants.PRIMARY,
      required: false,
      validator: (value) => Object.values(buttonVariants).includes(value),
    },

    confirmation: {
      type: String,
      default: null,
    },

    confirmationPlaceholder: {
      type: String,
      default: 'Type confirmation...',
    },
  },

  data() {
    return {
      confirmationValue: null,
    };
  },

  computed: {
    confirmable() {
      return this.confirmation !== null;
    },
    confirmationDoesntMatch() {
      return this.confirmationValue !== this.confirmation;
    },
  },

  methods: {
    handleConfirmation(e) {
      e.preventDefault();

      this.$emit('confirmed', e);
    },

    handleClose(e) {
      this.$emit('cancelled', e);
    },
  },

  components: {
    TModal,
    TButton,
  },
};
</script>
